import { render } from "./ElButtons.vue?vue&type=template&id=63896768"
import script from "./ElButtons.vue?vue&type=script&lang=js"
export * from "./ElButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__